import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
} from '@/components/ui/sidebar';
import { AddPageSidebarItem } from './add-page-sidebar-item';
import { PAGE_TEMPLATES, type SidebarSelection } from './page-template-types';

interface PageTemplatesGroupProps {
  selectedItem: SidebarSelection;
  onSelectItem: (key: SidebarSelection) => void;
}

export function PageTemplatesGroup({ selectedItem, onSelectItem }: PageTemplatesGroupProps) {
  return (
    <SidebarGroup className="p-0">
      <SidebarGroupLabel className="px-0">Page Templates</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          {PAGE_TEMPLATES.map((template) => (
            <AddPageSidebarItem
              key={template.key}
              icon={template.icon}
              label={template.label}
              description={template.description}
              isSelected={selectedItem === template.key}
              onClick={() => onSelectItem(template.key)}
            />
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
